import { createAction, props } from '@ngrx/store';
import { User } from '@lmc-app/shared/interface/user.interface';

// Load user
export const loadUser = createAction('[User] Load User');

export const loadUserSuccess = createAction(
	'[User] Load User Success',
	props<{ user: User }>()
);

export const loadUserFailure = createAction(
	'[User] Load User Failure',
	props<{ error: any }>()
);

// Session management
export const sessionExpired = createAction('[User] Session Expired');

export const authenticationError = createAction(
	'[User] Authentication Error',
	props<{ error: any }>()
);

export const checkAuthStatus = createAction('[User] Check Auth Status');

// Clear user (logout)
export const clearUser = createAction('[User] Clear User');

// Update user
export const updateUser = createAction(
	'[User] Update User',
	props<{ user: Partial<User> }>()
);
